var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{tag:"component",attrs:{"params":_vm.params,"invoice":_vm.invoice,"transaction":_vm.transaction},on:{"reload":function($event){return _vm.$emit('reload')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }